import React, { useMemo, useCallback } from "react";
import { generatePath } from "react-router";
import { useHistory, useParams} from "react-router-dom";
import PublicForm from "./PublicForm";
import PromiseWait from "../shared/PromiseWait";
import { publicRoutes } from "../../routePaths";
import { pruneJsonData } from "../../utils/jsonUtils";
import { getPublicTemplateDetails, savePublicFormInstance, getPublicPrefillData } from "../../stores/formsStore";
import { showFormSaveAcknowledgement } from '../../services/ToasterService';
import { augmentFormData } from "../shared/form/dynamicForm/utils";

interface IRouteParams {
  tiid: string;
  templateId: string;
  locationId: string;
}


async function loadData(tiid: string, templateId: string) {
  const [template, prefillData] = await Promise.all([getPublicTemplateDetails(tiid, templateId), getPublicPrefillData(tiid)]);
  return { template, prefillData: augmentFormData(prefillData, template) };
}

const PublicFormContainer: React.FC = () => {
  const { tiid, templateId, locationId } = useParams<IRouteParams>();
  const history = useHistory();
  const promise = useMemo(() => loadData(tiid, templateId), [tiid, templateId]);

  const onSubmit = useCallback((values: object) => {
    console.log("Saving public form. Template Id: " + templateId, values);
    return savePublicFormInstance(tiid, templateId, pruneJsonData(values), locationId);
  }, [tiid, templateId, locationId]);

  const onCompleted = useCallback(() => {
    const dest = generatePath(publicRoutes.forms.base, {tiid});
    showFormSaveAcknowledgement();
    history.replace(dest);
  }, [history, tiid]);

  const mapProps = useCallback(({template, prefillData}) => ({template, prefillData, onSubmit, onCompleted}),
    [onCompleted, onSubmit]);

  return (
    <PromiseWait promise={promise} mapComponentProps={mapProps} component={PublicForm} />
  );
}


export default PublicFormContainer;

